import React from 'react';
import { Grid, Modal } from '@material-ui/core';
import {
  useStyles,
  ModalCancelButton,
  ModalDeleteButton
} from '../parts/cloudStorage/style/style';

type Tprops = {
  name: string;
  openDeleteModal: boolean;
  setOpenDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  onDeleteFile: () => void;
};

export const DeleteModal: React.FC<Tprops> = (props: Tprops) => {
  const { name, openDeleteModal, setOpenDeleteModal, onDeleteFile } = props;

  const classes = useStyles();

  return (
    <Modal
      open={openDeleteModal}
      onClose={() => setOpenDeleteModal(false)}
      aria-labelledby='simple-modal-title'
      aria-describedby='simple-modal-description'
      className={classes.container}
    >
      <Grid container className={classes.subpaper}>
        <Grid item xs={12} className={classes.container}>
          <div style={{ textAlign: 'center' }}>
            <h1 style={{ marginBottom: 24, fontSize: 24 }}>資料を削除</h1>
            <p>{`${name}を削除しますか？`}</p>
          </div>
        </Grid>

        <Grid item xs={12} className={classes.modalFooter}>
          <ModalCancelButton
            variant='contained'
            onClick={() => {
              setOpenDeleteModal(false);
            }}
          >
            キャンセル
          </ModalCancelButton>
          <ModalDeleteButton variant='contained' onClick={onDeleteFile}>
            削除する
          </ModalDeleteButton>
        </Grid>
      </Grid>
    </Modal>
  );
};
